import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/fi';

dayjs.locale('fi');
dayjs.extend(relativeTime);

export default dayjs;
